import { Navigate, useLocation } from "react-router-dom";
import type { ReactNode } from "react";
import { canAccessRoute, getFirstAccessibleRoute } from "../core/adminPermissions";

const PermissionRoute = ({ children }: { children: ReactNode }) => {
  const location = useLocation();
  return canAccessRoute(location.pathname)
    ? <>{children}</>
    : <Navigate to={getFirstAccessibleRoute()} replace />;
};

export default PermissionRoute;
